class AzSearchBar extends HTMLElement {
  constructor() {
    super();

    this.searchInput = this.querySelector(".az-search-bar-input");
    this.searchList = this.querySelector(".az-predict-search-list");
    this.popularProductsDropdown = this.querySelector(
      ".az-popular-products-search"
    );
    this.serachForm = this.querySelector("#az-search-bar-form");
    this.searchListItemTemplate = this.querySelector(
      "#az-search-list-item-template"
    );
    this.searchInputLabel = this.querySelector(".az-search-bar-input-label");
    this.popularSearchs = this.querySelectorAll(
      ".az-popular-searches-list-item"
    );
    this.seachProductCards = this.querySelectorAll(
      ".az-search-bar-product-card"
    );

    this.initialSetup();
  }

  initialSetup() {
    this.searchInput.addEventListener("focus", this.openSearchList.bind(this));
    this.searchInput.addEventListener(
      "input",
      this.debounce(this.loadPredictiveSearch.bind(this), 300)
    );
    this.serachForm.addEventListener("submit", this.handleSubmit.bind(this));

    this.shop = window.Shopify.shop;
    this.timeOffset = this.dataset.timeOffset;
    this.pageTemplate = this.dataset.pageTemplate;
    this.predictCache = {};
    this.boundCloseSearchList = this.closeSearchList.bind(this);
    this.searchSubmitted = false;

    if (this.pageTemplate == "search") {
      this.searchEvent = new CustomEvent("formSubmitted", {
        detail: { searchQuery: "" },
      });
      this.searchInput.value = this.getQueryParam("q");
    } else if (
      this.pageTemplate == "product" &&
      this.getQueryParam("source") == "az-search"
    ) {
      document.addEventListener("DOMContentLoaded", () => {
        const journey = sessionStorage.getItem("atomz.ai");
        document
          .querySelectorAll('form[action="/cart/add"]')
          .forEach((element) => {
            const hiddenInput = document.createElement("input");
            hiddenInput.type = "hidden";
            hiddenInput.name = "attributes[_app_source]";
            hiddenInput.value = `atomz_search`;
            element.appendChild(hiddenInput);

            const productHandle = window.location.pathname
              .split("/")
              .pop()
              .replaceAll("-", "_");
            const searchHistory =
              journey +
              ` -> ${this.storeTimeFromUTC()}, product '${productHandle}'`;
            const hiddenSearchHistory = document.createElement("input");
            hiddenSearchHistory.type = "hidden";
            hiddenSearchHistory.name = `attributes[_journey_${productHandle}]`;
            hiddenSearchHistory.value = searchHistory;
            element.appendChild(hiddenSearchHistory);
          });
        sessionStorage.setItem(
          "atomz.ai",
          `${journey} -> ${window.location.pathname}`
        );
      });
    } else {
      sessionStorage.setItem(
        "atomz.ai",
        window.location.pathname == "/" ? "/home" : window.location.pathname
      );
    }

    this.popularSearchs.forEach((li) => {
      li.addEventListener("click", () => {
        appInsights.trackEvent({
          name: "InSearchSuggestionPromptClicked",
          properties: {
            promptText: li.textContent,
            storeName: this.shop,
          },
        });
        appInsights.flush();
        setTimeout(() => {
          this.handlePredictionSubmit(li.textContent);
        }, 500);
      });
    });

    this.seachProductCards.forEach((card) => {
      card.querySelector(".az-link").addEventListener("click", () => {
        appInsights.trackEvent({
          name: "InSearchProductClicked",
          properties: {
            productTitle: card.querySelector(
              ".az-search-bar-product-card-title"
            ).textContent,
            storeName: this.shop,
          },
        });
        appInsights.flush();
      });
    });
  }

  storeTimeFromUTC(offsetStr = this.timeOffset) {
    const sign = offsetStr[0];
    const hours = parseInt(offsetStr.substring(1, 3), 10);
    const minutes = parseInt(offsetStr.substring(3, 5), 10);
    let offsetMs = hours * 3600 * 1000 + minutes * 60 * 1000;
    if (sign === "-") {
      offsetMs = -offsetMs;
    }

    const nowUtc = Date.now();
    const targetTime = new Date(nowUtc + offsetMs);
    return targetTime.toISOString().replace("Z", "");
  }

  debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), delay);
    };
  }

  openSearchList() {
    this.searchSubmitted = false;
    if (this.searchInput.value == "") {
      this.toggleListDisplay(this.popularProductsDropdown, this.searchList);
    } else {
      this.loadPredictiveSearch();
      this.toggleListDisplay(this.searchList, this.popularProductsDropdown);
    }
    document.addEventListener("click", this.boundCloseSearchList);
  }

  closeSearchList(event) {
    if (!this.searchInput.contains(event.target)) {
      this.toggleListDisplay(
        this.searchList,
        this.popularProductsDropdown,
        true
      );
      this.searchInput.blur();
      document.removeEventListener("click", this.boundCloseSearchList);
    }
  }

  toggleListDisplay(openElement, closeElement, closeBoth = false) {
    if (closeBoth) {
      openElement.style.display = "none";
      openElement.style.opacity = "0";
    } else {
      openElement.style.display = "block";
      openElement.style.opacity = "1";
    }
    closeElement.style.display = "none";
    closeElement.style.opacity = "0";
  }

  async loadPredictiveSearch() {
    if (
      this.predictCache[this.searchInput.value] &&
      this.searchInput.value != ""
    ) {
      this.showPredictions(this.predictCache[this.searchInput.value]);
    } else if (this.searchInput.value == "") {
      this.toggleListDisplay(this.popularProductsDropdown, this.searchList);
    } else {
      try {
        let predictions = [];
        const response = await fetch(
          `search/suggest.json?q=${this.searchInput.value}&resources[type]=query`
        );
        const predictiveSearch = await response.json();
        predictiveSearch.resources.results.queries.forEach((obj) => {
          predictions.push(obj.text);
        });
        this.showPredictions(predictions);
        this.predictCache[this.searchInput.value] = predictions;
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error(`Error loading predictive suggestions:`, error);
        }
      }
    }
  }

  showPredictions(predictions) {
    this.searchList.innerHTML = "";
    if (!this.searchSubmitted) {
      this.toggleListDisplay(this.searchList, this.popularProductsDropdown);
    }
    if (predictions.length == 0) {
      const li = this.searchListItemTemplate.content.cloneNode(true);
      li.querySelector(
        ".az-predict-search-list-text"
      ).innerHTML = `Search For <b>"${this.searchInput.value}"</b>`;
      li.querySelector("li").addEventListener("click", () => {
        this.handlePredictionSubmit(this.searchInput.value);
      });
      this.searchList.appendChild(li);
    } else {
      predictions.forEach((word) => {
        const li = this.searchListItemTemplate.content.cloneNode(true);
        li.querySelector(".az-predict-search-list-text").textContent = word;
        li.querySelector("li").addEventListener("click", () => {
          this.handlePredictionSubmit(word);
        });
        this.searchList.appendChild(li);
      });
    }
  }

  handleSubmit(event) {
    if (this.searchInput.value == "") {
      event.preventDefault();
      return;
    }
    if (this.pageTemplate == "search") {
      event.preventDefault();
      this.triggerEvent(this.searchInput.value);
      this.toggleListDisplay(
        this.searchList,
        this.popularProductsDropdown,
        true
      );
      setTimeout(() => {
        this.searchInput.blur();
      }, 0);
    }
  }

  handlePredictionSubmit(word) {
    if (this.pageTemplate == "search") {
      this.triggerEvent(word);
      this.searchInput.value = word;
    } else {
      this.searchInput.value = word;
      this.serachForm.submit();
    }
  }

  triggerEvent(searchQuery) {
    this.searchSubmitted = true;
    this.searchEvent.detail.searchQuery = searchQuery;
    this.serachForm.dispatchEvent(this.searchEvent);
    this.updateQueryParam("q", searchQuery);
  }

  getQueryParam(param) {
    const urlObj = new URL(window.location.href);
    return urlObj.searchParams.get(param);
  }

  updateQueryParam(param, newVal) {
    const urlObj = new URL(window.location.href);
    urlObj.searchParams.set(param, newVal);
    window.history.replaceState(null, "", urlObj.toString());
  }
}

customElements.define("az-search-bar", AzSearchBar);

class AnimatedText extends HTMLElement {
  constructor() {
    super();
    this.text = this.dataset.text;
    if (this.text) {
      this.text = this.text.split(",");
      this.textElemet = this.querySelector("#animation-text");
      this.textElemet.addEventListener(
        "animationiteration",
        this.changeText.bind(this)
      );
      this.currentIndex = 1;
    }
  }

  changeText() {
    this.textElemet.innerHTML = this.text[this.currentIndex];
    this.currentIndex = (this.currentIndex + 1) % this.text.length;
  }
}

customElements.define("animate-text", AnimatedText);

class AtomzSticky extends HTMLElement {
  constructor() {
    super();
    this.headerContainer = document.querySelector(".header-wrapper");
    this.enableSticky = this.dataset.enableSticky;
    this.divType = this.dataset.stickyType;
    this.element = this;
    if (this.headerContainer) {
      this.setInitial();
    }
  }

  setInitial() {
    let vatiableLength = 0;
    if (this.divType == "suggestions") {
      vatiableLength = document.querySelector(
        `atomz-sticky[data-sticky-type="search-bar"]`
      ).offsetHeight;
      this.element.classList.add("az-sticky-div");
    } else if (this.divType == "discoveryPrompt") {
      vatiableLength = document.querySelector(
        `atomz-sticky[data-sticky-type="search-bar"]`
      ).offsetHeight;
      this.discoveryPromptSection = this.closest(
        'section[id^="shopify-section-sections"]'
      );
      this.discoveryPromptSection.classList.add(
        "az-sticky-div",
        "az-discovery-prompt-contianer"
      );
      this.element = this.discoveryPromptSection;
    } else {
      this.searchBarSection = this.closest(
        'section[id^="shopify-section-sections"]'
      );
      this.searchBarSection.classList.add("az-sticky-div", "az-search-bar");
      this.element = this.searchBarSection;
    }

    if (this.enableSticky != "true") return;

    this.element.style.top = `${vatiableLength}px`;

    if (this.headerContainer.dataset.stickyType == "always") {
      this.element.style.top = `${
        this.headerContainer.offsetHeight + vatiableLength
      }px`;
    } else if (this.headerContainer.dataset.stickyType == "on-scroll-up") {
      let lastScrollTop = 0;
      const headerHeight = this.headerContainer.offsetHeight;
      window.addEventListener("scroll", () => {
        let scrollTop = window.scrollY;
        if (scrollTop > lastScrollTop) {
          this.element.style.top = `${vatiableLength}px`;
        } else {
          this.element.style.top = `${headerHeight + vatiableLength}px`;
        }
        lastScrollTop = scrollTop;
      });
    } else if (this.headerContainer.dataset.stickyType == "reduce-logo-size") {
      const logoReduceFunction = () => {
        this.element.style.top = `${
          this.headerContainer.offsetHeight + vatiableLength
        }px`;
      };
      window.addEventListener("scroll", logoReduceFunction);
    }
  }
}

customElements.define("atomz-sticky", AtomzSticky);

class AtomzDiscoveryPrompts extends HTMLElement {
  constructor() {
    super();

    this.pageDataElement = document.querySelector("#page-data");

    // this.baseURL = "http://localhost:8000";
    // this.baseURL = "https://searchserviceappdevelopment-dghaeahaesf6bfcn.canadacentral-01.azurewebsites.net";
    this.baseURL =
      "https://searchserviceapp-hghfgwg9btg0c7b7.canadacentral-01.azurewebsites.net";

    this.initialSetup();
  }

  initialSetup() {
    this.pageDataJson = JSON.parse(this.pageDataElement.textContent);
    this.shop = window.Shopify.shop;
    this.suggestions = [];

    this.fetchSuggestions();
  }

  async fetchSuggestions() {
    try {
      const gptResponse = await fetch(
        `${this.baseURL}/search-service/query-discovery-propmts`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            page_data: this.pageDataJson,
            shop: this.shop,
          }),
        }
      );

      const gptResponseJson = await gptResponse.json();

      if (gptResponseJson.error) {
        console.log(gptResponseJson.error);
        return;
      }

      if (gptResponse.ok) {
        if (gptResponseJson.includes("|")) {
          this.suggestions = gptResponseJson.split("|");
        } else if (gptResponseJson.includes(",")) {
          this.suggestions = gptResponseJson.split(",");
        }

        if (typeof this.suggestions !== "string") this.showSuggestions();
        // console.log(this.suggestions);
      }
    } catch (error) {}
  }

  showSuggestions() {
    for (const suggestion of this.suggestions) {
      const suggestionDiv = document.createElement("a");
      suggestionDiv.href = `/search?q=${encodeURIComponent(suggestion).replace(
        /%20/g,
        "+"
      )}&p=${encodeURIComponent(this.pageDataJson.pageType)}`;
      suggestionDiv.classList = "az-discovery-prompts-text";
      suggestionDiv.textContent = suggestion;
      suggestionDiv.addEventListener("click", (event) => {
        event.preventDefault();
        appInsights.trackEvent({
          name: "DiscoveryPromptClicked",
          properties: {
            promptText: suggestion,
            storeName: this.shop,
            numberOFPrompts: this.suggestions.length,
            pageType: this.pageDataJson.pageType,
            pageTitle: this.pageDataJson.title,
          },
        });
        appInsights.flush();
        setTimeout(() => {
          window.location.href = `/search?q=${encodeURIComponent(
            suggestion
          ).replace(/%20/g, "+")}&p=${encodeURIComponent(
            this.pageDataJson.pageType
          )}`;
        }, 300);
      });
      suggestionDiv.addEventListener("contextmenu", (event) => {
        appInsights.trackEvent({
          name: "DiscoveryPromptClicked",
          properties: {
            promptText: suggestion,
            storeName: this.shop,
            numberOFPrompts: this.suggestions.length,
            pageType: this.pageDataJson.pageType,
            pageTitle: this.pageDataJson.title,
          },
        });
        appInsights.flush();
      });
      this.appendChild(suggestionDiv);
    }
    this.classList.remove("az-hidden");
  }
}

customElements.define("atomz-discovery-prompts", AtomzDiscoveryPrompts);
